import React from 'react'
import AuthContext from '../../../contexts/authContext';
import useAuth from '../../../hooks/useAuth';

type TAuthContextProvider = {
	children: React.ReactElement;
}

const AuthContextProvider = ({ children }: TAuthContextProvider) => {

	const { auth, isAuthenticated, loading } = useAuth();

	return (
		<AuthContext.Provider value={
			{
				gigyaAccount: auth,
				isLoggedIn: isAuthenticated,
				loading
			}
		}>
			{children}
		</AuthContext.Provider>
	)
}

export default AuthContextProvider